import { useMutation } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useIsVerified } from "../../context/UserContext";

export default function CountDownTimer({ innerText, request, className }) {
  const [timer, setTimer] = useState(0);
  const isVerified = useIsVerified();
  const CountDown = () => {
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev === 1) {
          clearInterval(interval);
          localStorage.removeItem("expireTime");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };
  //   const
  useEffect(() => {
    const storedTime = localStorage.getItem("expireTime");

    if (storedTime) {
      const remainingTime = Math.max(0, Math.ceil((storedTime - Date.now()) / 1000));
      if (remainingTime > 0) {
        setTimer(remainingTime);
        CountDown();
      }
    }
  }, []);
  const { mutate, isSuccess, isLoading, isError } = useMutation({
    mutationFn: request,
    onSuccess: () => {
      const expireTime = Date.now() + 60000;
      localStorage.setItem("expireTime", expireTime.toString());
      setTimer(60);
      CountDown();
    },
    onError: (e) => console.log(e),
  });
  useEffect(() => {
    if (isVerified) {
      localStorage.removeItem("expireTime");
    }
  }, [isVerified]);
  return (
    <button
      style={
        timer > 0 || isLoading
          ? {
              pointerEvents: "none",
            }
          : {}
      }
      onClick={() => {
        if (isLoading) return;

        mutate();
      }}
      className={className}>
      {isLoading
        ? "loading..."
        : isError
        ? "something went wrong, try again"
        : timer > 0
        ? `${timer} sec to resend`
        : innerText}
    </button>
  );
}
